<template>
  <div class="index">
    <div class="index-rule" @click="gotoRule"></div>
    <img :src="carPicture" class="index-car" />
    <div v-auth:click="gotoGame" class="index-game"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  created() {
    this.getCarImg();
  },
  computed: {
    ...mapState('config', ['carPicture']),
  },
  methods: {
    ...mapActions('goto', ['gotoGame', 'gotoRule']),
    ...mapActions('config', ['getCarImg']),
  },
};
</script>
<style lang="scss" scoped>
.index {
  background: url(~@this/assets/image-15.jpg) no-repeat;
  background-size: 750px 1334px;
  width: 750px;
  height: 1334px;
  position: relative;
  .index-rule {
    background: url(~@this/assets/image-17.png) no-repeat;
    background-size: 100% 100%;
    width: 57px;
    height: 158px;
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 1;
  }
  .index-car {
    width: 277px;
    height: 134px;
    position: absolute;
    right: 140px;
    top: 670px;
    z-index: 1;
  }
  .index-game {
    background: url(~@this/assets/image-16.png) no-repeat;
    background-size: 100% 100%;
    width: 402px;
    height: 95px;
    position: absolute;
    left: 0;
    right: 0;
    top: 860px;
    z-index: 1;
    margin: 0 auto;
  }
}
</style>
